import * as Yup from 'yup';
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { LayDcAdoptionDetailsWizard } from '../lay-dc/lay-dc-adoption-details-wizard';

export class RsvpAdoptionDetailsWizard extends LayDcAdoptionDetailsWizard {

	getFormContentModel(): LayDcPlanAdoptionContentModel {

		const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
		const content = super.getFormContentModel();

		return {
			...content,
			gpsType: GpsType.RsvpAdoptionDetail,
			pageTitle: institutionSettings?.adoptLayRSVPDetailsTitle,
			PageDescription: institutionSettings?.adoptRSVPDetailsDescription,
			submitLabel: institutionSettings?.adoptLayRSVPSubmitLabel,
			cancelLabel: institutionSettings?.adoptLayRSVPCancelLabel,
			hasEmployerContributionStatus: true,
			hasMemberType: true,
			isEmployerContributionRequired: false,
			docuSignSubject: institutionSettings?.adoptRSVPDocuSignSubject,
			docuSignFinishText: institutionSettings?.adoptRSVPDocusignFinishText,
			docuSignTemplateId: institutionSettings?.adoptRSVPDocuSignTemplateId,
			adoptEmployeeSalaryDeferText: institutionSettings?.adoptRSVPEmployeeSalaryDeferText,
			adoptEmployerContributionText: institutionSettings?.adoptRSVPEmployerContributionText,
			adoptEmployerBaseContributionLabel: institutionSettings?.adoptRSVPEmployerBaseContributionLabel,
			adoptEmployerMatchContributionLabel: institutionSettings?.adoptRSVPEmployerMatchContributionLabel,
			adoptMinScheduleHoursHelperText: institutionSettings?.adoptRSVPMinScheduleHoursHelperText,
			adoptMultipleContributionDescription: institutionSettings?.adoptRSVPMultipleContributionDescription,

		};
	}

	protected getAdditionalFieldValidationSchema(schema): any {

		const content = this.getFormContentModel();

		const newSchema = schema.shape({
			member_type: Yup.string().nullable().required(content?.adoptMemberTypeLabel),
			employer_contribution_status: Yup.string().nullable().required(content?.adoptEmployerContributionTitle),
		});

		return newSchema;
	}
}